import {Composed, Ventrata} from 'types'

export const getActualStripeIntent = (order: Ventrata.Order): Composed.VentrataStripeIntent => {
  if (!order.cardPayment) {
    throw new Error(`Card payment is not defined`)
  }

  if (order.cardPayment.gateway !== 'stripe') {
    throw new Error(`Unexpected card payment gateway '${order.cardPayment.gateway}'`)
  }

  if ('paymentIntent' in order.cardPayment.stripe && order.cardPayment.stripe.paymentIntent) {
    return {
      type: 'paymentIntent',
      ...order.cardPayment.stripe.paymentIntent,
    }
  }

  if ('setupIntent' in order.cardPayment.stripe && order.cardPayment.stripe.setupIntent) {
    return {
      type: 'setupIntent',
      ...order.cardPayment.stripe.setupIntent,
    }
  }

  throw new Error(`Can't find Stripe intent`)
}
